import { Card } from "antd";
import React, { ReactNode } from "react";
import { Grid } from "antd";

export const CardTitle = ({
  title,
  className,
  extra,
}: {
  title: string;
  className?: string;
  extra?: ReactNode;
}) => {
  const { useBreakpoint } = Grid;
  const { xs } = useBreakpoint();
  let isMobile = xs;
  return (
    <Card
      className={`card-title ${className}`}
      title={<div className="card-title__title">{title}</div>}
      size="small"
      extra={isMobile ? [] : extra}
      styles={{
        body: isMobile ? { textAlign: "center" } : { display: "none" },
      }}
    >
      {extra}
    </Card>
  );
};
